import { render, staticRenderFns } from "./ItsLogisticWaybill.vue?vue&type=template&id=62b1d0ba&scoped=true&"
import script from "./ItsLogisticWaybill.vue?vue&type=script&lang=js&"
export * from "./ItsLogisticWaybill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b1d0ba",
  null
  
)

export default component.exports